var Theme;
(function (Theme) {
  Theme["LIGHT"] = "light";
  Theme["DARK"] = "dark";
  Theme["NAVY"] = "navy";
  Theme["PERSONAL"] = "personal";
  Theme["PERSONAL_FOREST_GREEN"] = "personal--forest-green";
  Theme["PERSONAL_BRIGHT_GREEN"] = "personal--bright-green";
  Theme["PERSONAL_DARK"] = "personal--dark";
})(Theme || (Theme = {}));

export { Theme };
//# sourceMappingURL=theme.mjs.map
